import React from 'react';
import { IconButton } from '../../../../CommonComponents/OPL/IconButton/IconButton';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';

export interface Props {
  grantName: string;
  onEdit(): void;
  onDelete(): void;
}

export const TableActions = ({ grantName, onEdit, onDelete }: Props) => {
  return (
    <Box as="td" css="text-align: right; white-space: nowrap">
      <IconButton
        icon="far fa-pencil"
        variant="subtleInactive"
        onClick={evt => {
          evt.stopPropagation();
          onEdit();
        }}
        aria-label={`Edit ${grantName}`}
      />

      <IconButton
        icon="far fa-minus-circle"
        variant="subtleInactive"
        onClick={evt => {
          evt.stopPropagation();
          onDelete();
        }}
        aria-label={`Delete ${grantName}`}
      />
    </Box>
  );
};
